export const messagesApiHandler = {
  allConversations: {
    method: "GET",
    path: () => `conversations`,
    params: {} as {'courseId'?: string | number, 'status'?: string | number, 'skip'?: string | number, 'take'?: string | number}
  },
  getUnreadConversationCount: {
    method: "GET",
    path: () => `conversations/unread-count`
  },
  getSingleConversation: {
    method: "GET",
    path: (payload: { conversationId: string | number }) => `conversations/${payload.conversationId}`
  },
  composeConversation: {
    method: "POST",
    path: () => `conversations`
  },
  markAsStarred: {
    method: "PATCH",
    path: (payload: { conversationId: string | number }) => `conversations/${payload.conversationId}/toggle-starred`
  },
  markAsRead: {
    method: "PATCH",
    path: (payload: { conversationId: string | number }) => `conversations/${payload.conversationId}/mark-as-read`,
    params: {} as {}
  },
  getMessagesByConversationId: {
    method: "GET",
    path: (payload: { conversationId: string | number }) => `conversations/${payload.conversationId}/messages`,
    params: {} as {'skip'?: string | number, 'take'?: string | number}
  },
  messageReply: {
    method: "POST",
    path: (payload: { conversationId: string | number }) => `conversations/${payload.conversationId}/messages`
  }
};